import { DocumentListSection } from "../../../../../components/Proposal&Contracts/DocumentListSection.tsx"

export const defaultTermsAndConditions = [
  "Change Orders: All modifications must be approved in writing with revised pricing before commencement.",
  "Delays: Contractor not responsible for delays due to weather, permit issues, or supplier availability.",
  "Cancellation: Either party may cancel within 3 business days of signing (per California Civil Code §7159).",
  "Dispute Resolution: Any disputes will be resolved under California law in San Francisco County.",
  "Warranty Voidance: Unauthorized alterations or neglect may void warranties.",
  "Document Ownership: Plans and designs remain the property of Premier Construction Solutions until full payment is received."
]

export function ContractTermsSection() {
  return (
    <DocumentListSection
      title="Terms and Conditions"
      name="terms_and_conditions"
      infoPlaceholder="Terms and Conditions"
      itemPlaceholder="Terms and Conditions item"
      addButtonText="Terms and Conditions"
    />
  )
}
